import { diffTabularConfigs, MAX_TABULAR_CONFIG_DIFF_ENTRIES } from '@atbash-labs/ontology-core'
import type {
  MappedTabularIngestDefinition,
  TabularConfigDraftDiff
} from '@axilon-apps/domains-ontology-ui-state'

export const DEFINITION_DIFF_MAX_ENTRIES = MAX_TABULAR_CONFIG_DIFF_ENTRIES

/**
 * *Diff to previous* between two saved versions: the builder's own diff
 * (`diffTabularConfigs`, ontology-core), so a version's changed markers are
 * the ones its draft showed.
 */
export function definitionDiff(
  before: MappedTabularIngestDefinition,
  after: MappedTabularIngestDefinition,
  maxEntries = DEFINITION_DIFF_MAX_ENTRIES
): TabularConfigDraftDiff {
  return diffTabularConfigs(before, after, maxEntries)
}
